import { CustomerList } from "../pages/dashboard/customers/list";
import { SystemsPage } from "../pages/dashboard/customers/systems";
import { DeliveryAddressesPage } from "../pages/dashboard/customers/delivery-addresses";
import { DashboardReport } from "../pages/dashboard/report";
import { AiSkills } from "../pages/dashboard/ai/AiSkills";
import CommunityPage from "../pages/dashboard/community/index";
import { UserGuideHub } from "../pages/dashboard/user-guide/index";
import { UserGuideHoursGettingStarted } from "../pages/dashboard/user-guide/hours-getting-started";
import { UserGuideHseKsGettingStarted } from "../pages/dashboard/user-guide/hse-ks-getting-started";
import { UserGuideDrawingsGettingStarted } from "../pages/dashboard/user-guide/drawings-getting-started";
import { UserGuideOffersGettingStarted } from "../pages/dashboard/user-guide/offers-getting-started";
import { UserGuideCompanyGettingStarted } from "../pages/dashboard/UserGuideCompanyGettingStarted";
import { UserGuideProfileGettingStarted } from "../pages/dashboard/UserGuideProfileGettingStarted";
import { UserGuideChemicalInventoryGettingStarted } from "../pages/dashboard/user-guide/chemical-inventory-getting-started";
import { ChemicalInventoryList } from "../pages/dashboard/quality/chemical-inventory/list";
import { ChemicalInventoryView } from "../pages/dashboard/quality/chemical-inventory/view";
import { ProductsList } from "../pages/dashboard/products/list";
import { StandardLayout } from "../components/dashboard/standard-layout";
import { Product } from "../pages/dashboard/products/product";
import { Customer } from "../pages/dashboard/customers/customer";
import { EditCustomer } from "../pages/dashboard/customers/editCustomer";
import {
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  UsersIcon,
  WrenchIcon,
  Cog6ToothIcon,
  MapIcon,
  CheckCircleIcon,
  EnvelopeOpenIcon,
  BuildingOffice2Icon,
  ClipboardDocumentListIcon,
  CircleStackIcon,
  ClockIcon,
  FolderOpenIcon,
  AcademicCapIcon,
  PaperClipIcon,
  CalendarDaysIcon,
  CommandLineIcon,
  PhoneIcon,
  ComputerDesktopIcon,
  DocumentTextIcon,
  ShieldCheckIcon,
  Square3Stack3DIcon,
  ChatBubbleLeftRightIcon,
  BanknotesIcon,
  ExclamationTriangleIcon,
  BoltIcon,
  UserGroupIcon,
  PlusIcon,
  ListBulletIcon,
  BeakerIcon,
  InformationCircleIcon,
  PencilIcon,
  PencilSquareIcon,
  BookOpenIcon,
  ClipboardDocumentCheckIcon,
  SparklesIcon,
  TableCellsIcon,
  ArrowPathIcon,
  CubeIcon,
  BriefcaseIcon,
  FlagIcon,
} from "@heroicons/react/24/outline";
import { CustomerSettings } from "../pages/dashboard/customers/settings";
import { InventoryList } from "../pages/dashboard/inventory/list";
import { InventorySettings } from "../pages/dashboard/inventory/settings";
import { InventoryCounts } from "../pages/dashboard/inventory/counts";
import { InventoryCount } from "../pages/dashboard/inventory/count";
import { NewInventoryCount } from "../pages/dashboard/inventory/counts/new";
import WarehouseStock from "../pages/dashboard/inventory/warehouse-stock";
import InventoryValuation from "../pages/dashboard/inventory/valuation";
import { InventoryCorrections } from "../pages/dashboard/inventory/corrections";
import { InventoryCorrection } from "../pages/dashboard/inventory/correction";
import { Purchases } from "../pages/dashboard/inventory/purchases";
import { Purchase } from "../pages/dashboard/inventory/purchase";
import { GoodsReceipt } from "../pages/dashboard/inventory/goods-receipt";
import ItemHandlingPage from "../pages/dashboard/inventory/item-handling";
import PickingListPage from "../pages/dashboard/inventory/picking-list";
import { ProjectList } from "../pages/dashboard/projects/list";
import { ItemList } from "../pages/dashboard/projects/item-list";
import { ProjectItemListsSummary } from "../pages/dashboard/projects/project-item-lists-summary";
import { NoLayout } from "../components/dashboard/no-layout";
import { ServiceSettings } from "../pages/dashboard/service/settings";
import { ServiceReportGuides } from "../pages/dashboard/service/report-guides";
import { ServiceOverview } from "../pages/dashboard/service/overview";
import { OrdersList } from "../pages/dashboard/orders/list";
import { Order } from "../pages/dashboard/orders/order";
import { ReportView } from "../pages/dashboard/service/reports/report-view";
import { ProductsSettings } from "../pages/dashboard/products/settings";
import { ReportList } from "../pages/dashboard/service/reports/list";
import { CasesList } from "../pages/dashboard/cases/list";
import { CompanyIntegrations } from "../pages/dashboard/company/integrations";
import { CompanyMicrosoftOutlook } from "../pages/dashboard/company/companyMicrosoftOutlook";
import { Project } from "../pages/dashboard/projects/project";
import { ProjectArchive } from "../pages/dashboard/projects/project-archive";
import { ProjectEditPage } from "../pages/dashboard/projects/project-edit-page";
import { CompanySettings } from "../pages/dashboard/company/settings";
import { VehiclesList } from "../pages/dashboard/vehicles/list";
import { Vehicle } from "../pages/dashboard/vehicles/vehicle";
import DriverVehicleHandbook from "../pages/dashboard/driving/vehicles/vehicle-handbook";
import VehicleHandbookEntry from "../pages/dashboard/driving/vehicles/vehicle-handbook-entry";
import { DrivingTrips } from "../pages/dashboard/driving/trips/trips";
import { DrivingDrivers } from "../pages/dashboard/driving/drivers/drivers";
import { HourList } from "../pages/dashboard/hours/hours";
import { HourSettings } from "../pages/dashboard/hours/settings_v2";
import { WorkSchedulesAdmin } from "../pages/dashboard/hours/work-schedules";
import { ServiceAgreementList } from "../pages/dashboard/service/agreements/list";
import { ServiceAgreement } from "../pages/dashboard/service/agreements/agreement";
import { CompanyUsersList } from "../pages/dashboard/company/users/list";
import { User } from "../pages/dashboard/company/users/user";
import { HrEmployeesList } from "../pages/dashboard/hr/employees/list";
import { JobOpeningsList } from "../pages/dashboard/hr/job-openings/list";
import { JobOpeningShow } from "../pages/dashboard/hr/job-openings/show";
import { JobOpeningCandidateShow } from "../pages/dashboard/hr/job-openings/candidate";
import { HrSettings } from "../pages/dashboard/hr/settings";
import { ChecklistTypeView } from "../pages/dashboard/quality/settings/checklistType";
import { EmployeeHandbookView } from "../pages/dashboard/quality/personalhåndbok";
import { Folder } from "../pages/dashboard/projects/folder";
import { OrdersSettings } from "../pages/dashboard/orders/settings";
import { CaseSettings } from "../pages/dashboard/cases/settings";
import { CaseGuidesSettingsPage } from "../pages/dashboard/cases/case-guides";
import { ResourceHubFaqFront } from "../pages/dashboard/resource-hub/faq/front";
import { ResourceHubFaqPage } from "../pages/dashboard/resource-hub/faq/faqPage";
import { CaseStatsPage } from "../pages/dashboard/cases/stats";
import { StatisticsPage } from "../pages/dashboard/statistics";
import { ContactList } from "../pages/dashboard/contacts/list";
import { ContactPage } from "../pages/dashboard/contacts/contact";
import { ReportFinishPage } from "../pages/dashboard/service/reports/report-finish";
import { EditFaqPost } from "../pages/dashboard/resource-hub/faq/editPost";
import { HourSheet } from "../pages/dashboard/hours/hour_sheet";
import { WorkStats } from "../pages/dashboard/hours/work-stats";
import { HoursOverviewRedirect } from "../pages/dashboard/hours/hours-overview-redirect";
import { HoursBillingFollowup } from "../pages/dashboard/hours/billing-followup";
import { AnnouncementsPage } from "../pages/dashboard/company/announcements";
import { TrainingAdminRoute, TrainingAdminLegacyRedirect, TrainingUserRoute, TrainingResponsibleRoute } from "../components/dashboard/training/trainingAdminRoutes";
import { HoursApproval } from "../pages/dashboard/hours/approval";
import { HoursMonthlyOverview } from "../pages/dashboard/hours/monthly_overview";
import { HoursCompanyOverview } from "../pages/dashboard/hours/company-overview";
import { HoursPayrollBasis } from "../pages/dashboard/hours/payroll_basis";
import { HoursResourcePlan } from "../pages/dashboard/hours/resource_plan";
import { OutboundCommunicationsList } from "../pages/dashboard/communications/list";
import { OutboundCommunicationShow } from "../pages/dashboard/communications/show";
import MonetizationOn from "@mui/icons-material/MonetizationOn";
import { OffersList } from "../pages/dashboard/offers/list";
import { Offer } from "../pages/dashboard/offers/offer";
import { OffersSettings } from "../pages/dashboard/offers/settings";
import PDFViewer from "../pages/dashboard/PDFViewer";
import { TemplateList } from "../pages/dashboard/templates/list";
import { TemplatePage } from "../pages/dashboard/templates/template";
import { JournalsList } from "../pages/dashboard/journals/list";
import { TextDocumentsList } from "../pages/dashboard/text-documents/list";
import { TextDocumentPage } from "../pages/dashboard/text-documents/document";
import { UserProfile } from "../pages/dashboard/users/userProfile";
import { WebpagesList } from "../pages/dashboard/webpage/pages/list";
import { WebpageEditor } from "../pages/dashboard/webpage/pages/pageEditor";
import CaseView from "../pages/dashboard/cases/caseView";
import { EditAbsence } from "../pages/dashboard/absence/editAbsence";
import { ViewUserWorkSchedule } from "../pages/dashboard/workSchedule/view";
import { AbsenceOverview } from "../pages/dashboard/absence/overview";
import { WorkOrderList } from "../pages/dashboard/workOrder/list";
import { UserSettings } from "../pages/dashboard/users/userSettings";
import { UserMicrosoftOutlook } from "../pages/dashboard/users/userMicrosoftOutlook";
import { ShowCommuncation } from "../pages/dashboard/customers/communcations/showCommuncation";
import { ReadWorkOrder } from "../pages/dashboard/workOrder/readWorkOrder";
import { WorkOrderChecklistPage } from "../pages/dashboard/workOrder/work-order-checklist-page";
import { WorkOrderItemConsumptionPage } from "../pages/dashboard/workOrder/work-order-item-consumption-page";
import { ProjectCategoriesList } from "../pages/dashboard/projects/settings/categories/list";
import { ProjectTaskTemplatesSettings } from "../pages/dashboard/projects/settings/task-templates";
import { NewProjectCategory } from "../pages/dashboard/projects/settings/categories/new";
import { EditProjectCategory } from "../pages/dashboard/projects/settings/categories/edit";
import { ProjectPlan } from "../pages/dashboard/projects/projectPlan";
import { CrewScheduling } from "../pages/dashboard/projects/crewScheduling";
import { CalendarView } from "../pages/dashboard/calendar/calendar";
import ControlPanel from "../pages/dashboard/sentralbord";
import { CompanyHistory } from "../pages/dashboard/company/history";
import { ToolsOverview } from "../pages/dashboard/tools/overview.js";
import { ToolView } from "../pages/dashboard/tools/tool-view.js";
import { HseEventsView } from "../pages/dashboard/hse/events";
import { HseEventView } from "../pages/dashboard/hse/event";
import { HseSafetyInspectionPage } from "../components/dashboard/hse/hseSafetyInspectionPage";
import { ReportViewV2 } from "../pages/dashboard/service/reports/report-view-v2";
import { ReportFinishPageV2 } from "../pages/dashboard/service/reports/report-finish-v2";
import { ReportChecklistPage } from "../pages/dashboard/service/reports/report-checklist-page";
import { ReportVariablesPage } from "../pages/dashboard/service/reports/report-variables-page";
import { ReportItemConsumptionPage } from "../pages/dashboard/service/reports/report-item-consumption-page";
import CompanySubscription from "../pages/dashboard/company/subscription";
import { MeetingMinutesList } from "../pages/dashboard/meeting-minutes/list";
import { MeetingMinutesView } from "../pages/dashboard/meeting-minutes/view";
import { MeetingMinutesEditor } from "../pages/dashboard/meeting-minutes/editor";
import { MeetingMinutesMeetingView } from "../pages/dashboard/meeting-minutes/meeting";
import { MeetingMinutesNewMeeting } from "../pages/dashboard/meeting-minutes/new-meeting";
import { MeetingMinutesTemplatesList } from "../pages/dashboard/meeting-minutes/templates/list";
import { MeetingMinutesTemplateEditor } from "../pages/dashboard/meeting-minutes/templates/editor";
import { DrawingsList } from "../pages/dashboard/drawings/list";
import { DrawingEditor } from "../pages/dashboard/drawings/editor";
import { DrawingViewer } from "../pages/dashboard/drawings/viewer";
import { ProjectIfcViewer } from "../pages/dashboard/ifc-viewer/project-viewer";
import CustomerHandler from "../pages/dashboard/customer-handler";
import { TodoList } from "../pages/dashboard/todos/list";
import { TodoSettings } from "../pages/dashboard/todos/settings";
import { MyStatusUpdates, RedirectOppdateringerToStatusUpdates } from "../pages/dashboard/statusUpdates/MyStatusUpdates";
import { AccountingOverviewPage } from "../pages/dashboard/accounting/overview";
import { AccountingLedgerPage } from "../pages/dashboard/accounting/ledger";
import { AccountingResultReportPage } from "../pages/dashboard/accounting/result-report";
import { AccountingProjectsExpectedIncomePage } from "../pages/dashboard/accounting/projects-expected-income";
import AccountingProjectSummaryPage from "../pages/dashboard/accounting/project-summary";
import { AccountingTripletexImportPage } from "../pages/dashboard/accounting/tripletex-import";
import { SupplierInvoiceList } from "../pages/dashboard/supplier-invoices/list";
import { SupplierInvoiceDetail } from "../pages/dashboard/supplier-invoices/detail";
import { CustomerInvoiceList } from "../pages/dashboard/customer-invoices/list";
import { CustomerInvoiceDetail } from "../pages/dashboard/customer-invoices/detail";
import { AdminPayslips, MyPayslips, PayslipStats } from "../pages/dashboard/payslips/list";
import { OfferCalculationsList } from "../pages/dashboard/offers/calculations/list";
import { OfferCalculation } from "../pages/dashboard/offers/calculations/calculation";
import { OfferCalculationHourRatesList } from "../pages/dashboard/offers/hour-rates/list";
import { OfferCalculationHourRate } from "../pages/dashboard/offers/hour-rates/hour-rate";
import { ProductCategoriesList } from "../pages/dashboard/products/categories/list";

// HSE/KS Imports
import { HseKsDashboard } from "../pages/dashboard/hse-ks/dashboard";
import { HseKsEventsList } from "../pages/dashboard/hse-ks/events/list";
import { HseKsEventView } from "../pages/dashboard/hse-ks/events/view";
import { HseKsEventEdit } from "../pages/dashboard/hse-ks/events/edit";
import { HseKsDeviationsList } from "../pages/dashboard/hse-ks/events/deviations";
import { DeviationsList } from "../pages/dashboard/quality/deviations/list";
import { DeviationView } from "../pages/dashboard/quality/deviations/deviation";
import { EditDeviation } from "../pages/dashboard/quality/deviations/editDeviation";
import { DeviationNotificationSettings } from "../pages/dashboard/quality/deviations/settings";
import { HseKsNearMissesList } from "../pages/dashboard/hse-ks/events/near-misses";
import { HseKsAccidentsList } from "../pages/dashboard/hse-ks/events/accidents";
import { HseKsComplaintsList } from "../pages/dashboard/hse-ks/events/complaints";
import { HseKsObservationsList } from "../pages/dashboard/hse-ks/events/observations";
import { HseKsRiskHub } from "../pages/dashboard/hse-ks/risk/hub";
import { HseKsRiskCampaign } from "../pages/dashboard/hse-ks/risk/campaign";
import { HseKsRiskRegister } from "../pages/dashboard/hse-ks/risk/register";
import { HseKsRiskView } from "../pages/dashboard/hse-ks/risk/view";
import { HseKsRiskEdit } from "../pages/dashboard/hse-ks/risk/edit";
import { HseKsRiskMatrix } from "../pages/dashboard/hse-ks/risk/matrix";
import { HseKsClimateRisk } from "../pages/dashboard/hse-ks/risk/climate";
import { HseKsSjaList } from "../pages/dashboard/hse-ks/risk/sja/list";
import { HseKsSjaView } from "../pages/dashboard/hse-ks/risk/sja/view";
import { HseKsSjaEdit } from "../pages/dashboard/hse-ks/risk/sja/edit";
import { HseKsChemicalInventoryList } from "../pages/dashboard/hse-ks/risk/chemical-inventory/list";
import { HseKsChemicalInventoryView } from "../pages/dashboard/hse-ks/risk/chemical-inventory/view";
import { HseKsProtectiveEquipmentList } from "../pages/dashboard/hse-ks/risk/protective-equipment/list";
import { HseKsProtectiveEquipmentView } from "../pages/dashboard/hse-ks/risk/protective-equipment/view";
import { HseKsOrgChartsList } from "../pages/dashboard/hse-ks/documents/org-charts/list";
import { HseKsOrgChartView } from "../pages/dashboard/hse-ks/documents/org-charts/view";
import { HseKsOrgChartEditor } from "../pages/dashboard/hse-ks/documents/org-charts/editor";
import { HseKsChecklistsList } from "../pages/dashboard/hse-ks/documents/checklists/list";
import { HseKsChecklistView } from "../pages/dashboard/hse-ks/documents/checklists/view";
import { HseKsChecklistCreate } from "../pages/dashboard/hse-ks/documents/checklists/create";
import { HseKsDocumentsList } from "../pages/dashboard/hse-ks/documents/list";
import { HseKsDocumentView } from "../pages/dashboard/hse-ks/documents/view";
import { HseKsDocumentEdit } from "../pages/dashboard/hse-ks/documents/edit";
import { HseKsDocumentVersions } from "../pages/dashboard/hse-ks/documents/versions";
import { HseKsDocumentApproval } from "../pages/dashboard/hse-ks/documents/approval";
import { DocumentFormTemplatesList } from "../pages/dashboard/hse-ks/documents/form-templates/list";
import { DocumentFormTemplatePage } from "../pages/dashboard/hse-ks/documents/form-templates/template";
import { DocumentFormsList } from "../pages/dashboard/hse-ks/documents/forms/list";
import { DocumentFormPage } from "../pages/dashboard/hse-ks/documents/forms/form";
import { HseKsDocumentGuide } from "../pages/dashboard/hse-ks/documents/guide";
import { HseKsDocumentReadOverview } from "../pages/dashboard/hse-ks/documents/read-overview";
import { HseKsDocumentEmployees } from "../pages/dashboard/hse-ks/documents/employees";
import { HseKsEmployeeRoutines } from "../pages/dashboard/hse-ks/documents/employee-routines";
import { HseKsCompetencyMyView } from "../pages/dashboard/hse-ks/competency/my";
import { HseKsCompetencyMatrix } from "../pages/dashboard/hse-ks/competency/matrix";
import { HseKsCompetencyMatrixRole } from "../pages/dashboard/hse-ks/competency/matrix-role";
import { HseKsCompetencyDefinitions } from "../pages/dashboard/hse-ks/competency/definitions";
import { HseKsCompetencyDefinitionView } from "../pages/dashboard/hse-ks/competency/definition-view";
import { HseKsCompetencyDefinitionEdit } from "../pages/dashboard/hse-ks/competency/definition-edit";
import { HseKsCompetencyEmployees } from "../pages/dashboard/hse-ks/competency/employees";
import { HseKsCompetencyEmployeeView } from "../pages/dashboard/hse-ks/competency/employee-view";
import { HseKsCompetencyCourses } from "../pages/dashboard/hse-ks/competency/courses";
import { HseKsCompetencyCourseView } from "../pages/dashboard/hse-ks/competency/course-view";
import { HseKsCompetencyCourseEdit } from "../pages/dashboard/hse-ks/competency/course-edit";
import { HseKsCompetencyExpiring } from "../pages/dashboard/hse-ks/competency/expiring";
import { HseKsCompetencyTrainingPlan } from "../pages/dashboard/hse-ks/competency/training-plan";
import { HseKsCompetencyTrainingPlanEdit } from "../pages/dashboard/hse-ks/competency/training-plan-edit";
import { HseKsCompetencyRolesList } from "../pages/dashboard/hse-ks/competency/roles/list";
import { HseKsCompetencyRoleEdit } from "../pages/dashboard/hse-ks/competency/roles/edit";
import { HseKsCompetencyEmployeeAssign } from "../pages/dashboard/hse-ks/competency/employees/assign";
import { HseKsCompetencyGuide } from "../pages/dashboard/hse-ks/competency/guide";
import { HseKsEvaluationOverview } from "../pages/dashboard/hse-ks/evaluation/overview";
import { HseKsKpiDashboard } from "../pages/dashboard/hse-ks/evaluation/kpi-dashboard";
import { HseKsKpiDefinitions } from "../pages/dashboard/hse-ks/evaluation/kpi/definitions";
import { HseKsKpiDefinitionView } from "../pages/dashboard/hse-ks/evaluation/kpi/definition-view";
import { HseKsKpiDefinitionEdit } from "../pages/dashboard/hse-ks/evaluation/kpi/definition-edit";
import { HseKsKpiMeasurements } from "../pages/dashboard/hse-ks/evaluation/kpi/measurements";
import { HseKsKpiMeasurementEdit } from "../pages/dashboard/hse-ks/evaluation/kpi/measurement-edit";
import { HseKsAuditsList } from "../pages/dashboard/hse-ks/evaluation/audits/list";
import { HseKsAuditView } from "../pages/dashboard/hse-ks/evaluation/audits/view";
import { HseKsAuditEdit } from "../pages/dashboard/hse-ks/evaluation/audits/edit";
import { HseKsAuditFindings } from "../pages/dashboard/hse-ks/evaluation/audits/findings";
import { HseKsAuditReport } from "../pages/dashboard/hse-ks/evaluation/audits/report";
import { HseKsManagementReviewList } from "../pages/dashboard/hse-ks/evaluation/management-review/list";
import { HseKsManagementReviewView } from "../pages/dashboard/hse-ks/evaluation/management-review/view";
import { HseKsManagementReviewEdit } from "../pages/dashboard/hse-ks/evaluation/management-review/edit";
import { HseKsCustomerFeedback } from "../pages/dashboard/hse-ks/evaluation/customer-feedback";
import { HseKsSettings } from "../pages/dashboard/hse-ks/settings";
import { HseKsGoals } from "../pages/dashboard/hse-ks/goals";
import { HseKsTiltakList } from "../pages/dashboard/hse-ks/tiltak/list";
import { HseKsTiltakEdit } from "../pages/dashboard/hse-ks/tiltak/edit";
import { HseKsTiltakView } from "../pages/dashboard/hse-ks/tiltak/view";
import { CompanyDepartmentsList } from "../pages/dashboard/company/departments/list";
import { NewOffer } from "../pages/dashboard/offers/new";

interface Route {
  title?: string;
  path?: string;
  sidebar?: boolean;
  sidebarBottom?: boolean;
  role?: string;
  roles?: string[];
  feature?: string;
  action?: string;
  requireAdmin?: boolean;
  requireAllRoles?: boolean;
  icon?: JSX.Element;
  element?: JSX.Element;
  layout?: JSX.Element;
}

export const DashboardRoutes = [
  {
    title: "Dashboard",
    path: "/dashboard/",
    sidebar: true,
    role: "",
    icon: HomeIcon,
    element: DashboardReport,
    layout: NoLayout,
  },
  {
    title: "trainingParticipant.title",
    path: "/dashboard/training",
    sidebar: true,
    role: "",
    icon: AcademicCapIcon,
    element: TrainingUserRoute,
    layout: NoLayout,
  },
  {
    title: "trainingAdmin.responsibleReports",
    path: "/dashboard/training/reports",
    sidebar: false,
    role: "",
    icon: AcademicCapIcon,
    element: TrainingResponsibleRoute,
    layout: NoLayout,
  },
  {
    title: "community.title",
    path: "/dashboard/community",
    sidebar: false,
    sidebarBottom: true,
    role: "",
    icon: ChatBubbleLeftRightIcon,
    element: CommunityPage,
    layout: NoLayout,
  },
  {
    title: "Brukerguide",
    path: "/dashboard/guide",
    sidebar: false,
    role: "",
    icon: BookOpenIcon,
    element: UserGuideHub,
    layout: NoLayout,
  },
  {
    title: "Brukerguide — timer",
    path: "/dashboard/guide/hours",
    sidebar: false,
    role: "admin",
    icon: BookOpenIcon,
    element: UserGuideHoursGettingStarted,
    layout: NoLayout,
  },
  {
    title: "Brukerguide — HMS",
    path: "/dashboard/guide/hse-ks",
    sidebar: false,
    role: "admin",
    icon: BookOpenIcon,
    element: UserGuideHseKsGettingStarted,
    layout: NoLayout,
  },
  {
    title: "Brukerguide — tegninger",
    path: "/dashboard/guide/drawings",
    sidebar: false,
    roles: ["drawings", "drawings_edit"],
    icon: BookOpenIcon,
    element: UserGuideDrawingsGettingStarted,
    layout: NoLayout,
  },
  {
    title: "Brukerguide — tilbud",
    path: "/dashboard/guide/offers",
    sidebar: false,
    role: "admin",
    icon: BookOpenIcon,
    element: UserGuideOffersGettingStarted,
    layout: NoLayout,
  },
  {
    title: "Brukerguide — firma",
    path: "/dashboard/guide/company",
    sidebar: false,
    role: "admin",
    icon: BookOpenIcon,
    element: UserGuideCompanyGettingStarted,
    layout: NoLayout,
  },
  {
    title: "Brukerguide — min profil",
    path: "/dashboard/guide/profile",
    sidebar: false,
    role: "",
    icon: BookOpenIcon,
    element: UserGuideProfileGettingStarted,
    layout: NoLayout,
  },
  {
    title: "Brukerguide — stoffkartotek",
    path: "/dashboard/guide/chemical-inventory",
    sidebar: false,
    role: "admin",
    icon: BeakerIcon,
    element: UserGuideChemicalInventoryGettingStarted,
    layout: NoLayout,
  },
  {
    title: "AI skills",
    path: "/dashboard/ai/skills",
    sidebar: false,
    role: "",
    icon: SparklesIcon,
    element: AiSkills,
    layout: NoLayout,
  },
  {
    title: "todo.sidebarTitle",
    path: "/dashboard/todos",
    sidebar: true,
    role: "",
    icon: ClipboardDocumentListIcon,
    element: TodoList,
    layout: NoLayout,
    children: [
      {
        title: "todo.settingsTitle",
        path: "/dashboard/todos/settings",
        sidebar: false,
        requireAdmin: true,
        role: "",
        icon: Cog6ToothIcon,
        element: TodoSettings,
        layout: NoLayout,
      },
    ],
  },
  {
    title: "status_update.mine_title",
    path: "/dashboard/status-updates",
    sidebar: true,
    role: "",
    icon: PencilSquareIcon,
    element: MyStatusUpdates,
    layout: NoLayout,
  },
  {
    title: "status_update.mine_title",
    path: "/dashboard/oppdateringer",
    sidebar: false,
    role: "",
    icon: PencilSquareIcon,
    element: RedirectOppdateringerToStatusUpdates,
    layout: NoLayout,
  },
  {
    title: "Kundebehandleren",
    path: "/dashboard/customer-handler",
    sidebar: true,
    role: "customer-handler",
    action: "read",
    icon: ChatBubbleLeftRightIcon,
    element: CustomerHandler,
    layout: NoLayout,
  },
  {
    title: "Sentralbord",
    path: "/dashboard/sentralbord",
    sidebar: false,
    role: "phone",
    icon: ComputerDesktopIcon,
    element: ControlPanel,
    layout: NoLayout,
  },
  {
    title: "PDF Viewer",
    path: "/dashboard/pdf_viewer",
    role: "",
    sidebar: false,
    icon: ClockIcon,
    element: PDFViewer,
    layout: NoLayout,
    children: [
      {
        title: "PDF Viewer",
        role: "",
        path: "/dashboard/pdf_viewer/:id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: PDFViewer,
      },
    ],
  },
  {
    title: "Kalender",
    path: "/dashboard/calendar",
    role: "calendar",
    sidebar: true,
    icon: CalendarDaysIcon,
    element: CalendarView,
    layout: StandardLayout,
  },
  {
    title: "Mannskap og vaktplan",
    path: "/dashboard/crew",
    roles: ["projects_plan", "hours", "edit_hours", "hours_approval"],
    feature: "crew_scheduling",
    sidebar: true,
    icon: UserGroupIcon,
    element: CrewScheduling,
    layout: NoLayout,
  },
  {
    title: "Hours",
    path: "/dashboard/hours",
    role: "hours",
    sidebar: true,
    icon: ClockIcon,
    layout: NoLayout,
    // Hours module: timeregistrering bruker kun project_activity (prosjektlinjer); vis ikke legacy activity_id i disse visningene.
    children: [
      {
        title: "Hours Overview",
        role: "hours",
        action: "read",
        path: "/dashboard/hours/overview",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: HoursOverviewRedirect,
      },
      {
        title: "hourBilling.followup",
        role: "edit_hours",
        feature: "hours",
        path: "/dashboard/hours/billing-followup",
        sidebar: true,
        icon: ClockIcon,
        element: HoursBillingFollowup,
      },
      {
        title: "Timeliste",
        role: "hours",
        action: "read",
        path: "/dashboard/hours",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: HourSheet,
      },
      {
        title: "hours.company_overview",
        role: "hours_overview",
        feature: "hours",
        action: "read",
        path: "/dashboard/hours/time-overview",
        sidebar: true,
        icon: ClockIcon,
        element: HoursCompanyOverview,
      },
      {
        title: "Månedsoversikt",
        role: "hours",
        action: "read",
        path: "/dashboard/hours/monthly-overview",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: HoursMonthlyOverview,
      },
      {
        title: "Work Statistics",
        role: "hours",
        action: "read",
        path: "/dashboard/hours/stats",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: WorkStats,
      },
      {
        title: "Ressursplan",
        role: "hours",
        action: "read",
        path: "/dashboard/hours/resource-plan",
        sidebar: true,
        icon: UserGroupIcon,
        element: HoursResourcePlan,
      },
      {
        title: "Work Statistics",
        role: "hours",
        action: "read",
        path: "/dashboard/hours/stats/:user_id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: WorkStats,
      },
      {
        title: "Hour List",
        role: "hours",
        action: "read",
        path: "/dashboard/hours",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: HourList,
      },
      {
        title: "hours",
        role: "hours",
        action: "read",
        path: "/dashboard/hours/:id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: HourSheet,
      },
      {
        title: "Approval",
        role: "hours_approval",
        action: "read",
        path: "/dashboard/hours/approval",
        sidebar: true,
        icon: CheckCircleIcon,
        element: HoursApproval,
      },
      {
        title: "Tidsplan",
        role: "work_schedule",
        action: "read",
        path: "/dashboard/users/work_schedule",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: ViewUserWorkSchedule,
      },
      {
        title: "Nytt fravær",
        role: "hours_register",
        action: "read",
        path: "/dashboard/absences/new",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: EditAbsence,
      },
      {
        title: "Fravær",
        role: "hours_register",
        action: "update",
        path: "/dashboard/absences/:id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: EditAbsence,
      },
      {
        title: "Fravær",
        role: "hours_register",
        action: "read",
        path: "/dashboard/absences/overview",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: AbsenceOverview,
      },
      {
        title: "Settings",
        role: "hour_settings",
        action: "read",
        path: "/dashboard/hours/settings",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: HourSettings,
      },
      {
        title: "Arbeidsplaner",
        role: "hour_settings",
        action: "read",
        path: "/dashboard/hours/work-schedules",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: WorkSchedulesAdmin,
      },
    ],
  },
  {
    title: "Lønn",
    path: "/dashboard/payslips",
    roles: ["payslips", "payslips_admin"],
    feature: "payslips",
    sidebar: true,
    icon: BanknotesIcon,
    layout: NoLayout,
    children: [
      {
        title: "Mine lønnslipper",
        path: "/dashboard/payslips",
        roles: ["payslips", "payslips_admin"],
        feature: "payslips",
        sidebar: true,
        icon: BanknotesIcon,
        element: MyPayslips,
      },
      {
        title: "Statistikk",
        path: "/dashboard/payslips/statistics",
        roles: ["payslips", "payslips_admin"],
        feature: "payslips",
        sidebar: true,
        icon: ChartBarIcon,
        element: PayslipStats,
      },
      {
        title: "Lønnslipper",
        path: "/dashboard/payslips/admin",
        roles: ["admin", "payslips_admin"],
        requireAdmin: true,
        requireAllRoles: true,
        feature: "payslips",
        action: "read",
        sidebar: true,
        icon: BanknotesIcon,
        element: AdminPayslips,
      },
      // Meny under Lønn; URL beholdes under /hours. Krever bedriftsadmin + payslips_admin.
      {
        title: "Lønnsgrunnlag",
        roles: ["admin", "payslips_admin"],
        requireAdmin: true,
        requireAllRoles: true,
        feature: "hours",
        action: "read",
        path: "/dashboard/hours/payroll-basis",
        sidebar: true,
        icon: BanknotesIcon,
        element: HoursPayrollBasis,
      },
    ],
  },
  {
    title: "Customers",
    path: "/dashboard/customers",
    role: "customers",
    sidebar: true,
    icon: UsersIcon,
    layout: NoLayout,
    children: [
      {
        title: "Customer List",
        role: "customers",
        action: "read",
        path: "/dashboard/customers",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: CustomerList,
      },
      {
        title: "customer.systems.all_title",
        role: "customers", action: "read", path: "/dashboard/customer-systems",
        sidebar: true, icon: Cog6ToothIcon, element: SystemsPage,
      },
      {
        title: "deliveryRegistry.title",
        role: "customers", action: "read", path: "/dashboard/delivery-addresses",
        sidebar: true, icon: Cog6ToothIcon, element: DeliveryAddressesPage,
      },
      {
        title: "Communcations",
        // `communcations` is not a real JWT role — only admin passed the old gate.
        // Report users have service_reports; customer card uses customers.
        roles: ["customers", "customer-handler", "service", "service_reports"],
        action: "read",
        path: "/dashboard/customers/:customer_id/communications/:id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: ShowCommuncation,
      },
      {
        title: "Customer",
        role: "customers",
        action: "read",
        path: "/dashboard/customers/:id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: Customer,
      },
      {
        title: "Edit Customer",
        role: "customers",
        action: "edit",
        path: "/dashboard/customers/:id/edit",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: EditCustomer,
      },
      {
        title: "Contacts",
        role: "contacts",
        action: "read",
        path: "/dashboard/contacts/",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: ContactList,
      },
      {
        title: "Contacts",
        role: "contacts",
        action: "read",
        path: "/dashboard/contacts/:id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: ContactPage,
      },
      {
        title: "Delivery Adresses",
        role: "delivery_addresses",
        action: "read",
        path: "/dashboard/customers/:id",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: Customer,
      },
      {
        title: "Settings",
        role: "customer_settings",
        action: "read",
        path: "/dashboard/customers/settings",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: CustomerSettings,
      },
    ],
  },

  {
    title: "Projects",
    path: "/dashboard/projects",
    roles: ["projects", "projects_plan", "projects_accounting"],
    sidebar: true,
    icon: BuildingOffice2Icon,
    layout: NoLayout,
    children: [
      {
        title: "List",
        role: "projects",
        action: "read",
        path: "/dashboard/projects",
        sidebar: true,
        icon: FolderIcon,
        element: ProjectList,
      },
      {
        title: "Work Orders",
        role: "projects_work-orders",
        action: "read",
        path: "/dashboard/work_orders",
        sidebar: true,
        icon: FolderIcon,
        element: WorkOrderList,
      },
      {
        title: "Edit Work Order",
        role: "projects_work-orders",
        action: "create",
        path: "/dashboard/work_orders/new",
        sidebar: false,
        icon: FolderIcon,
        element: ReadWorkOrder,
      },
      {
        title: "Edit Work Order",
        role: "projects_work-orders",
        /** Utførere har ofte bare `read` på modulrollen; AO-deltakerrettigheter styrer felt (notat, vare, dokument). */
        actions: ["read", "edit"],
        path: "/dashboard/work_orders/edit/:id",
        sidebar: false,
        icon: FolderIcon,
        element: ReadWorkOrder,
      },
      {
        title: "Read Work Order",
        role: "projects_work-orders",
        action: "read",
        path: "/dashboard/work_orders/:id",
        sidebar: false,
        icon: FolderIcon,
        element: ReadWorkOrder,
      },
      {
        title: "Work Order Checklist",
        role: "projects_work-orders",
        action: "read",
        path: "/dashboard/work_orders/:id/checklist",
        sidebar: false,
        icon: FolderIcon,
        element: WorkOrderChecklistPage,
      },
      {
        title: "Work Order Item Consumption",
        role: "projects_work-orders",
        path: "/dashboard/work_orders/:id/item-consumption",
        sidebar: false,
        icon: FolderIcon,
        element: WorkOrderItemConsumptionPage,
      },
      {
        title: "Project",
        roles: ["projects", "projects_plan", "projects_accounting"],
        allowProjectParticipant: true,
        path: "/dashboard/projects/:id",
        sidebar: false,
        icon: FolderIcon,
        element: Project,
      },
      {
        title: "Project archive",
        roles: ["projects", "projects_plan", "projects_accounting"],
        allowProjectParticipant: true,
        path: "/dashboard/projects/:id/archive",
        sidebar: false,
        icon: FolderIcon,
        element: ProjectArchive,
      },
      {
        title: "IFC Viewer",
        roles: ["ifc_viewer", "ifc_viewer_edit"],
        feature: "ifc_viewer",
        path: "/dashboard/projects/:projectId/ifc-viewer",
        sidebar: false,
        icon: CubeIcon,
        element: ProjectIfcViewer,
      },
      {
        title: "Edit Project",
        role: "projects",
        action: "edit",
        path: "/dashboard/projects/:id/edit",
        sidebar: false,
        icon: FolderIcon,
        element: ProjectEditPage,
      },
      {
        title: "Project Plan",
        roles: ["projects_plan"],
        path: "/dashboard/projects/plan",
        sidebar: true,
        icon: CalendarDaysIcon,
        element: ProjectPlan,
      },
      {
        title: "Project Plan",
        roles: ["projects_plan"],
        path: "/dashboard/projects/:project_id/plan",
        sidebar: false,
        icon: CalendarDaysIcon,
        element: ProjectPlan,
      },
      {
        title: "Folder",
        role: "projects",
        action: "read",
        path: "/dashboard/projects/:project_id/folders/:folder_id",
        sidebar: false,
        icon: FolderIcon,
        element: Folder,
      },
      {
        title: "Item lists summary",
        role: "projects",
        action: "read",
        path: "/dashboard/projects/:id/item-lists/summary",
        sidebar: false,
        icon: ClipboardDocumentListIcon,
        element: ProjectItemListsSummary,
      },
      {
        title: "Item List",
        role: "projects",
        action: "read",
        path: "/dashboard/projects/item-lists/:id",
        sidebar: false,
        icon: ClipboardDocumentListIcon,
        element: ItemList,
      },
      {
        title: "Settings",
        role: "project_settings",
        action: "read",
        path: "/dashboard/projects/settings/categories",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: ProjectCategoriesList,
      },
      {
        title: "projectTaskTemplate.title",
        role: "project_settings",
        action: "read",
        path: "/dashboard/projects/settings/task-templates",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: ProjectTaskTemplatesSettings,
      },
      {
        title: "New Category",
        role: "project_settings",
        action: "read",
        path: "/dashboard/projects/settings/categories/new",
        sidebar: false,
        icon: FolderIcon,
        element: NewProjectCategory,
      },
      {
        title: "Edit Category",
        role: "project_settings",
        action: "read",
        path: "/dashboard/projects/settings/categories/:id/edit",
        sidebar: false,
        icon: FolderIcon,
        element: EditProjectCategory,
      },
    ],
  },

  {
    title: "HMS & KS",
    path: "/dashboard/hse-ks",
    roles: ["hse_ks", "quality"],
    sidebar: true,
    icon: ShieldCheckIcon,
    element: DashboardReport,
    layout: NoLayout,
    children: [
      // Dashboard - Main overview
      {
        title: "Dashboard",
        path: "/dashboard/hse-ks/dashboard",
        roles: ["hse_ks", "quality"],
        sidebar: true,
        icon: HomeIcon,
        element: HseKsDashboard,
      },

      // Hendelser (Events) - Main topic
      {
        title: "Hendelser",
        path: "/dashboard/hse-ks/events",
        role: "hse_ks_events",
        sidebar: true,
        icon: ExclamationTriangleIcon,
        element: HseKsEventsList,
        children: [
          // Overview - all events
          {
            title: "Oversikt",
            path: "/dashboard/hse-ks/events",
            role: "hse_ks_events",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsEventsList,
          },
          // Create new event
          {
            title: "Ny hendelse",
            path: "/dashboard/hse-ks/events/new",
            role: "hse_ks_events",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsEventEdit,
          },
          // Event details
          {
            title: "Hendelse",
            path: "/dashboard/hse-ks/events/:id",
            role: "hse_ks_events",
            action: "read",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: HseKsEventView,
          },
          // Edit event
          {
            title: "Rediger hendelse",
            path: "/dashboard/hse-ks/events/:id/edit",
            role: "hse_ks_events",
            action: "edit",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: HseKsEventEdit,
          },
          // Filtered views - Hendelse-avvik (Event deviations)
          {
            title: "Avvik (hendelser)",
            path: "/dashboard/hse-ks/events/deviations",
            role: "hse_ks_events",
            action: "read",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: HseKsDeviationsList,
          },
          {
            title: "Nestenulykker",
            path: "/dashboard/hse-ks/events/near-misses",
            role: "hse_ks_events",
            action: "read",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: HseKsNearMissesList,
          },
          {
            title: "Ulykker",
            path: "/dashboard/hse-ks/events/accidents",
            role: "hse_ks_events",
            action: "read",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: HseKsAccidentsList,
          },
          {
            title: "Reklamasjoner",
            path: "/dashboard/hse-ks/events/complaints",
            role: "hse_ks_events",
            action: "read",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: HseKsComplaintsList,
          },
          {
            title: "Observasjoner",
            path: "/dashboard/hse-ks/events/observations",
            role: "hse_ks_events",
            action: "read",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: HseKsObservationsList,
          },
        ],
      },

      {
        title: "Tiltak",
        path: "/dashboard/hse-ks/tiltak",
        roles: ["hse_ks", "quality"],
        sidebar: true,
        icon: ClipboardDocumentCheckIcon,
        element: HseKsTiltakList,
        children: [
          {
            title: "Tiltak",
            path: "/dashboard/hse-ks/tiltak",
            roles: ["hse_ks", "quality"],
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsTiltakList,
          },
          {
            title: "Nytt tiltak",
            path: "/dashboard/hse-ks/tiltak/new",
            roles: ["hse_ks", "quality"],
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsTiltakEdit,
          },
          {
            title: "Tiltak",
            path: "/dashboard/hse-ks/tiltak/:id",
            roles: ["hse_ks", "quality"],
            action: "read",
            sidebar: false,
            icon: ClipboardDocumentCheckIcon,
            element: HseKsTiltakView,
          },
          {
            title: "Rediger tiltak",
            path: "/dashboard/hse-ks/tiltak/:id/edit",
            roles: ["hse_ks", "quality"],
            action: "edit",
            sidebar: false,
            icon: PencilIcon,
            element: HseKsTiltakEdit,
          },
        ],
      },

      {
        title: "Målsetting",
        path: "/dashboard/hse-ks/goals",
        roles: ["hse_ks", "quality"],
        sidebar: true,
        icon: FlagIcon,
        element: HseKsGoals,
      },

      // Risiko & SJA (Risk & Job Safety Analysis) - Main topic
      {
        title: "Risiko & SJA",
        path: "/dashboard/hse-ks/risk",
        role: "hse_ks_risk",
        sidebar: true,
        icon: BoltIcon,
        element: HseKsRiskHub,
        children: [
          {
            title: "Risikovurderinger",
            path: "/dashboard/hse-ks/risk",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsRiskHub,
          },
          {
            title: "Risikoregister",
            path: "/dashboard/hse-ks/risk/register",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsRiskRegister,
          },
          {
            title: "Risikovurdering",
            path: "/dashboard/hse-ks/risk/campaigns/:campaignId",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: BoltIcon,
            element: HseKsRiskCampaign,
          },
          {
            title: "Ny risiko",
            path: "/dashboard/hse-ks/risk/new",
            role: "hse_ks_risk",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsRiskEdit,
          },
          // Risk details
          {
            title: "Risiko",
            path: "/dashboard/hse-ks/risk/:id",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: BoltIcon,
            element: HseKsRiskView,
          },
          // Edit risk
          {
            title: "Rediger risiko",
            path: "/dashboard/hse-ks/risk/:id/edit",
            role: "hse_ks_risk",
            action: "edit",
            sidebar: false,
            icon: BoltIcon,
            element: HseKsRiskEdit,
          },
          // Risk matrix visualization
          {
            title: "Risikomatrise",
            path: "/dashboard/hse-ks/risk/matrix",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: BoltIcon,
            element: HseKsRiskMatrix,
          },
          // Climate risk assessment
          {
            title: "Klimarisiko",
            path: "/dashboard/hse-ks/risk/climate",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: BoltIcon,
            element: HseKsClimateRisk,
          },
          // SJA List
          {
            title: "SJA Oversikt",
            path: "/dashboard/hse-ks/risk/sja",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsSjaList,
          },
          // Create new SJA
          {
            title: "Ny SJA",
            path: "/dashboard/hse-ks/risk/sja/new",
            role: "hse_ks_risk",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsSjaEdit,
          },
          // SJA details
          {
            title: "SJA",
            path: "/dashboard/hse-ks/risk/sja/:id",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: BoltIcon,
            element: HseKsSjaView,
          },
          // Edit SJA
          {
            title: "Rediger SJA",
            path: "/dashboard/hse-ks/risk/sja/:id/edit",
            role: "hse_ks_risk",
            action: "edit",
            sidebar: false,
            icon: BoltIcon,
            element: HseKsSjaEdit,
          },
          // Chemical Inventory (Stoffkartotek)
          {
            title: "Stoffkartotek",
            path: "/dashboard/hse-ks/risk/chemical-inventory",
            roles: ["hse_ks_risk", "chemical_inventory"],
            action: "read",
            sidebar: false,
            icon: BeakerIcon,
            element: HseKsChemicalInventoryList,
          },
          // Chemical Inventory details
          {
            title: "Stoffkartotek detaljer",
            path: "/dashboard/hse-ks/risk/chemical-inventory/:id",
            roles: ["hse_ks_risk", "chemical_inventory"],
            action: "read",
            sidebar: false,
            icon: BeakerIcon,
            element: HseKsChemicalInventoryView,
          },
          // Protective Equipment (Vernerunder)
          {
            title: "Vernerunder",
            path: "/dashboard/hse-ks/risk/protective-equipment",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: ShieldCheckIcon,
            element: HseKsProtectiveEquipmentList,
          },
          {
            title: "Vernerunde",
            path: "/dashboard/hse-ks/risk/protective-equipment/:id",
            role: "hse_ks_risk",
            action: "read",
            sidebar: false,
            icon: ShieldCheckIcon,
            element: HseKsProtectiveEquipmentView,
          },
        ],
      },

      // Dokumenter (Documents) - Main topic
      {
        title: "Dokumenter",
        path: "/dashboard/hse-ks/documents",
        roles: ["hse_ks_documents", "quality"],
        sidebar: true,
        icon: DocumentTextIcon,
        element: HseKsDocumentsList,
        children: [
          // Document library overview (sidebar link — parent "Dokumenter" only expands submenu)
          {
            title: "Dokumentbibliotek",
            path: "/dashboard/hse-ks/documents",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: true,
            icon: ListBulletIcon,
            element: HseKsDocumentsList,
          },
          // Create new document
          {
            title: "Nytt dokument",
            path: "/dashboard/hse-ks/documents/new",
            role: "hse_ks_documents",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsDocumentEdit,
          },
          // Filtered views by document type (static paths before :id)
          {
            title: "Policyer",
            path: "/dashboard/hse-ks/documents/policies",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          {
            title: "Prosedyrer",
            path: "/dashboard/hse-ks/documents/procedures",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          {
            title: "Instrukser",
            path: "/dashboard/hse-ks/documents/instructions",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          {
            title: "Skjemaer",
            path: "/dashboard/hse-ks/documents/forms",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          {
            title: "Veiledninger",
            path: "/dashboard/hse-ks/documents/guidance",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          {
            title: "Registreringer",
            path: "/dashboard/hse-ks/documents/record",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          {
            title: "Maler",
            path: "/dashboard/hse-ks/documents/template",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          // Fillable form templates + archive (static paths before :id)
          {
            title: "Utfyllbare maler",
            path: "/dashboard/hse-ks/documents/templates",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: true,
            icon: DocumentTextIcon,
            element: DocumentFormTemplatesList,
          },
          {
            title: "Ny mal",
            path: "/dashboard/hse-ks/documents/templates/new",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: DocumentFormTemplatePage,
          },
          {
            title: "Rediger mal",
            path: "/dashboard/hse-ks/documents/templates/:id",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: DocumentFormTemplatePage,
          },
          {
            title: "Utfylte dokument",
            path: "/dashboard/hse-ks/documents/form-archive",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: true,
            icon: DocumentTextIcon,
            element: DocumentFormsList,
          },
          {
            title: "Nytt utfylt dokument",
            path: "/dashboard/hse-ks/documents/form-archive/new",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: DocumentFormsList,
          },
          {
            title: "Utfylt dokument",
            path: "/dashboard/hse-ks/documents/form-archive/:id",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: DocumentFormPage,
          },
          // Guide
          {
            title: "Guide",
            path: "/dashboard/hse-ks/documents/guide",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: InformationCircleIcon,
            element: HseKsDocumentGuide,
          },
          {
            title: "Lest / forstått",
            path: "/dashboard/hse-ks/documents/read-status",
            role: "hse_ks_documents",
            action: "read",
            sidebar: true,
            icon: CheckCircleIcon,
            element: HseKsDocumentReadOverview,
          },
          {
            title: "hseCompliance.employees.title",
            path: "/dashboard/hse-ks/documents/employees",
            role: "hse_ks_documents",
            action: "read",
            sidebar: true,
            icon: UserGroupIcon,
            element: HseKsDocumentEmployees,
          },
          {
            title: "hseCompliance.routines.title",
            path: "/dashboard/hse-ks/documents/employees/:userId",
            role: "hse_ks_documents",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsEmployeeRoutines,
          },
          // Archive
          {
            title: "Arkiv",
            path: "/dashboard/hse-ks/documents/obsolete",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentsList,
          },
          // Dynamic document routes — must come after all static path segments
          {
            title: "Dokument",
            path: "/dashboard/hse-ks/documents/:id",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentView,
          },
          {
            title: "Rediger dokument",
            path: "/dashboard/hse-ks/documents/:id/edit",
            role: "hse_ks_documents",
            action: "edit",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentEdit,
          },
          {
            title: "Versjonshistorikk",
            path: "/dashboard/hse-ks/documents/:id/versions",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentVersions,
          },
          {
            title: "Godkjenning",
            path: "/dashboard/hse-ks/documents/:id/approve",
            role: "hse_ks_documents_approve",
            action: "approve",
            sidebar: false,
            icon: DocumentTextIcon,
            element: HseKsDocumentApproval,
          },
        ],
      },

      // Kompetanse (Competency) - Main topic
      {
        title: "Kompetanse",
        path: "/dashboard/hse-ks/competency",
        role: "hse_ks_competency",
        sidebar: true,
        icon: UserGroupIcon,
        element: HseKsCompetencyMyView,
        children: [
          {
            title: "trainingAdmin.title",
            path: "/dashboard/hse-ks/competency/training",
            role: "admin",
            sidebar: false,
            icon: AcademicCapIcon,
            element: TrainingAdminRoute,
          },
          // My competencies
          {
            title: "Min kompetanse",
            path: "/dashboard/hse-ks/competency",
            role: "hse_ks_competency",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsCompetencyMyView,
          },
          // Competency matrix (management)
          {
            title: "Kompetansematrise",
            path: "/dashboard/hse-ks/competency/matrix",
            role: "hse_ks_competency_manage",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyMatrix,
          },
          // Competency matrix for specific role
          {
            title: "Kompetansematrise rolle",
            path: "/dashboard/hse-ks/competency/matrix/:role",
            role: "hse_ks_competency_manage",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyMatrixRole,
          },
          // Roles list
          {
            title: "Roller",
            path: "/dashboard/hse-ks/competency/roles",
            role: "hse_ks_competency_manage",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsCompetencyRolesList,
          },
          // Create new role
          {
            title: "Ny rolle",
            path: "/dashboard/hse-ks/competency/roles/new",
            role: "hse_ks_competency_manage",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsCompetencyRoleEdit,
          },
          // Edit role
          {
            title: "Rediger rolle",
            path: "/dashboard/hse-ks/competency/roles/:id/edit",
            role: "hse_ks_competency_manage",
            action: "edit",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyRoleEdit,
          },
          // Competency Guide
          {
            title: "Kompetanse Guide",
            path: "/dashboard/hse-ks/competency/guide",
            role: "hse_ks_competency",
            action: "read",
            sidebar: false,
            icon: InformationCircleIcon,
            element: HseKsCompetencyGuide,
          },
          // Competency definitions
          {
            title: "Kompetansedefinisjoner",
            path: "/dashboard/hse-ks/competency/definitions",
            role: "hse_ks_competency_manage",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsCompetencyDefinitions,
          },
          // Create new competency
          {
            title: "Ny kompetanse",
            path: "/dashboard/hse-ks/competency/definitions/new",
            role: "hse_ks_competency_manage",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsCompetencyDefinitionEdit,
          },
          // Edit competency definition
          {
            title: "Rediger kompetanse",
            path: "/dashboard/hse-ks/competency/definitions/:id/edit",
            role: "hse_ks_competency_manage",
            action: "edit",
            sidebar: false,
            icon: PencilIcon,
            element: HseKsCompetencyDefinitionEdit,
          },
          // Competency definition details
          {
            title: "Kompetanse",
            path: "/dashboard/hse-ks/competency/definitions/:id",
            role: "hse_ks_competency",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyDefinitionView,
          },
          // Employee overview (management)
          {
            title: "Ansattoversikt",
            path: "/dashboard/hse-ks/competency/employees",
            role: "hse_ks_competency_manage",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsCompetencyEmployees,
          },
          // Assign competency to employee (must come before :id route)
          {
            title: "Tildel kompetanse",
            path: "/dashboard/hse-ks/competency/employees/:id/assign",
            role: "hse_ks_competency_manage",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsCompetencyEmployeeAssign,
          },
          // Employee competency details
          {
            title: "Ansatt kompetanse",
            path: "/dashboard/hse-ks/competency/employees/:id",
            role: "hse_ks_competency_manage",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyEmployeeView,
          },
          // Courses list
          {
            title: "Kurs",
            path: "/dashboard/hse-ks/competency/courses",
            role: "hse_ks_competency",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsCompetencyCourses,
          },
          // Create new course
          {
            title: "Nytt kurs",
            path: "/dashboard/hse-ks/competency/courses/new",
            role: "hse_ks_competency_manage",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsCompetencyCourseEdit,
          },
          // Course details
          {
            title: "Kurs",
            path: "/dashboard/hse-ks/competency/courses/:id",
            role: "hse_ks_competency",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyCourseView,
          },
          // Expiring competencies
          {
            title: "Utløper snart",
            path: "/dashboard/hse-ks/competency/expiring",
            role: "hse_ks_competency",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyExpiring,
          },
          // Training plan
          {
            title: "Opplæringsplan",
            path: "/dashboard/hse-ks/competency/training-plan",
            role: "hse_ks_competency_manage",
            action: "read",
            sidebar: false,
            icon: UserGroupIcon,
            element: HseKsCompetencyTrainingPlan,
          },
          // Create training plan item
          {
            title: "Ny opplæringsplan",
            path: "/dashboard/hse-ks/competency/training-plan/new",
            role: "hse_ks_competency_manage",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsCompetencyTrainingPlanEdit,
          },
          // Edit training plan item
          {
            title: "Rediger opplæringsplan",
            path: "/dashboard/hse-ks/competency/training-plan/:id/edit",
            role: "hse_ks_competency_manage",
            action: "edit",
            sidebar: false,
            icon: PencilIcon,
            element: HseKsCompetencyTrainingPlanEdit,
          },
        ],
      },

      // Evaluering (Evaluation) - Main topic
      {
        title: "Evaluering",
        path: "/dashboard/hse-ks/evaluation",
        role: "hse_ks_evaluation",
        sidebar: true,
        icon: ChartBarIcon,
        element: HseKsEvaluationOverview,
        children: [
          // Evaluation overview
          {
            title: "Oversikt",
            path: "/dashboard/hse-ks/evaluation",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsEvaluationOverview,
          },
          // KPI Dashboard
          {
            title: "KPI Dashboard",
            path: "/dashboard/hse-ks/evaluation/kpi",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsKpiDashboard,
          },
          // KPI Definitions
          {
            title: "KPI Definisjoner",
            path: "/dashboard/hse-ks/evaluation/kpi/definitions",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsKpiDefinitions,
          },
          // Create new KPI
          {
            title: "Ny KPI",
            path: "/dashboard/hse-ks/evaluation/kpi/definitions/new",
            role: "hse_ks_evaluation",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsKpiDefinitionEdit,
          },
          // KPI details
          {
            title: "KPI",
            path: "/dashboard/hse-ks/evaluation/kpi/definitions/:id",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsKpiDefinitionView,
          },
          // KPI Measurements
          {
            title: "Målinger",
            path: "/dashboard/hse-ks/evaluation/kpi/measurements",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsKpiMeasurements,
          },
          // Create new measurement
          {
            title: "Ny måling",
            path: "/dashboard/hse-ks/evaluation/kpi/measurements/new",
            role: "hse_ks_evaluation",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsKpiMeasurementEdit,
          },
          // Internal Audits
          {
            title: "Internrevisjon",
            path: "/dashboard/hse-ks/evaluation/audits",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsAuditsList,
          },
          // Create new audit
          {
            title: "Ny revisjon",
            path: "/dashboard/hse-ks/evaluation/audits/new",
            role: "hse_ks_evaluation",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsAuditEdit,
          },
          // Audit details
          {
            title: "Revisjon",
            path: "/dashboard/hse-ks/evaluation/audits/:id",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsAuditView,
          },
          // Edit audit
          {
            title: "Rediger revisjon",
            path: "/dashboard/hse-ks/evaluation/audits/:id/edit",
            role: "hse_ks_evaluation",
            action: "edit",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsAuditEdit,
          },
          // Audit findings
          {
            title: "Revisjonsfunn",
            path: "/dashboard/hse-ks/evaluation/audits/:id/findings",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsAuditFindings,
          },
          // Audit report
          {
            title: "Revisjonsrapport",
            path: "/dashboard/hse-ks/evaluation/audits/:id/report",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsAuditReport,
          },
          // Management Review
          {
            title: "Ledelsens gjennomgang",
            path: "/dashboard/hse-ks/evaluation/management-review",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsManagementReviewList,
          },
          // Create new review
          {
            title: "Ny gjennomgang",
            path: "/dashboard/hse-ks/evaluation/management-review/new",
            role: "hse_ks_evaluation",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsManagementReviewEdit,
          },
          // Review details
          {
            title: "Gjennomgang",
            path: "/dashboard/hse-ks/evaluation/management-review/:id",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsManagementReviewView,
          },
          // Edit review
          {
            title: "Rediger gjennomgang",
            path: "/dashboard/hse-ks/evaluation/management-review/:id/edit",
            role: "hse_ks_evaluation",
            action: "edit",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsManagementReviewEdit,
          },
          // Customer feedback
          {
            title: "Kundetilfredshet",
            path: "/dashboard/hse-ks/evaluation/customer-feedback",
            role: "hse_ks_evaluation",
            action: "read",
            sidebar: false,
            icon: ChartBarIcon,
            element: HseKsCustomerFeedback,
          },
        ],
      },

      // Avvik (Deviations) - Main topic - Endringsmelding/Aviksmelding
      {
        title: "Avvik",
        path: "/dashboard/hse-ks/deviations",
        role: "quality_deviations",
        sidebar: true,
        icon: ExclamationTriangleIcon,
        element: DeviationsList,
        children: [
          // Deviations list
          {
            title: "Avvik",
            path: "/dashboard/hse-ks/deviations",
            role: "quality_deviations",
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: DeviationsList,
          },
          // Create new deviation
          {
            title: "Nytt avvik",
            path: "/dashboard/hse-ks/deviations/new",
            role: "quality_deviations",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: EditDeviation,
          },
          {
            title: "Innstillinger for avviksvarsel",
            path: "/dashboard/hse-ks/deviations/settings",
            role: "admin",
            action: "update",
            sidebar: false,
            icon: Cog6ToothIcon,
            element: DeviationNotificationSettings,
          },
          // Deviation details
          {
            title: "Avvik",
            path: "/dashboard/hse-ks/deviations/:id",
            role: "quality_deviations",
            action: "read",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: DeviationView,
          },
          // Edit deviation
          {
            title: "Rediger avvik",
            path: "/dashboard/hse-ks/deviations/:id/edit",
            role: "quality_deviations",
            action: "edit",
            sidebar: false,
            icon: ExclamationTriangleIcon,
            element: EditDeviation,
          },
        ],
      },

      // Sjekklister (Checklists) - Main topic
      {
        title: "Sjekklister",
        path: "/dashboard/hse-ks/checklists",
        roles: ["hse_ks_documents", "quality"],
        sidebar: true,
        icon: ClipboardDocumentListIcon,
        element: HseKsChecklistsList,
        children: [
          // Checklists list
          {
            title: "Sjekklister",
            path: "/dashboard/hse-ks/checklists",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsChecklistsList,
          },
          // Create new checklist
          {
            title: "Ny sjekkliste",
            path: "/dashboard/hse-ks/checklists/new",
            role: "hse_ks_documents",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsChecklistCreate,
          },
          // Checklist details
          {
            title: "Sjekkliste",
            path: "/dashboard/hse-ks/checklists/:id",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: ClipboardDocumentListIcon,
            element: HseKsChecklistView,
          },
          // Edit checklist
          {
            title: "Rediger sjekkliste",
            path: "/dashboard/hse-ks/checklists/:id/edit",
            role: "hse_ks_documents",
            action: "edit",
            sidebar: false,
            icon: ClipboardDocumentListIcon,
            element: HseKsChecklistCreate,
          },
        ],
      },

      // Organisasjonskart (Org Charts) - Main topic
      {
        title: "Organisasjonskart",
        path: "/dashboard/hse-ks/org-charts",
        roles: ["hse_ks_documents", "quality"],
        sidebar: false,
        icon: BuildingOffice2Icon,
        element: HseKsOrgChartsList,
        children: [
          // Org Charts list
          {
            title: "Organisasjonskart",
            path: "/dashboard/hse-ks/org-charts",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: ListBulletIcon,
            element: HseKsOrgChartsList,
          },
          // Create new org chart
          {
            title: "Nytt organisasjonskart",
            path: "/dashboard/hse-ks/org-charts/new",
            role: "hse_ks_documents",
            action: "create",
            sidebar: false,
            icon: PlusIcon,
            element: HseKsOrgChartEditor,
          },
          // Org Chart details
          {
            title: "Organisasjonskart",
            path: "/dashboard/hse-ks/org-charts/:id",
            roles: ["hse_ks_documents", "quality"],
            action: "read",
            sidebar: false,
            icon: BuildingOffice2Icon,
            element: HseKsOrgChartView,
          },
          // Edit org chart
          {
            title: "Rediger organisasjonskart",
            path: "/dashboard/hse-ks/org-charts/:id/edit",
            role: "hse_ks_documents",
            action: "edit",
            sidebar: false,
            icon: BuildingOffice2Icon,
            element: HseKsOrgChartEditor,
          },
        ],
      },

      // Settings
      {
        title: "Innstillinger",
        path: "/dashboard/hse-ks/settings",
        role: "hse_ks_settings",
        action: "read",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: HseKsSettings,
        children: [
          {
            title: "Sjekklistetype",
            path: "/dashboard/hse-ks/settings/checklistType/:id",
            role: "hse_ks_settings",
            action: "read",
            sidebar: false,
            icon: ClipboardDocumentListIcon,
            element: ChecklistTypeView,
          },
        ],
      },
    ],
  },

  {
    title: "Cases",
    path: "/dashboard/cases",
    roles: ["cases", "cases_create", "cases_write", "cases_edit"],
    feature: "cases",
    sidebar: true,
    icon: EnvelopeOpenIcon,
    layout: NoLayout,
    children: [
      {
        title: "New Case",
        roles: ["cases_create"],
        action: "create",
        feature: "cases",
        path: "/dashboard/cases/new",
        sidebar: false,
        icon: FolderIcon,
        element: CaseView,
      },
      {
        title: "Case",
        feature: "cases",
        path: "/dashboard/cases/:id",
        sidebar: false,
        icon: FolderIcon,
        element: CaseView,
      },
      {
        title: "List",
        roles: ["cases", "cases_create", "cases_write", "cases_edit"],
        action: "read",
        feature: "cases",
        path: "/dashboard/cases",
        sidebar: true,
        icon: FolderIcon,
        element: CasesList,
      },
      {
        title: "Stats",
        roles: ["cases", "cases_edit"],
        feature: "cases",
        path: "/dashboard/cases/stats",
        sidebar: true,
        icon: FolderIcon,
        element: CaseStatsPage,
      },
      {
        title: "Settings",
        roles: ["cases", "cases_edit"],
        feature: "cases",
        path: "/dashboard/cases/settings",
        sidebar: true,
        icon: FolderIcon,
        element: CaseSettings,
      },
      {
        title: "Case Guides",
        roles: ["cases", "cases_edit"],
        feature: "cases",
        path: "/dashboard/cases/settings/case-guides",
        sidebar: false,
        icon: ClipboardDocumentCheckIcon,
        element: CaseGuidesSettingsPage,
      },
    ],
  },
  {
    title: "Statistikk",
    path: "/dashboard/statistics",
    role: "cases",
    sidebar: true,
    icon: ChartBarIcon,
    layout: NoLayout,
    element: StatisticsPage,
  },
  {
    title: "Products",
    path: "/dashboard/products",
    role: "products",
    sidebar: true,
    icon: FolderOpenIcon,
    layout: NoLayout,
    children: [
      // Produkter routes
      {
        title: "Produkter",
        role: "products",
        action: "read",
        path: "/dashboard/products",
        sidebar: true,
        icon: FolderIcon,
        element: ProductsList,
      },
      {
        title: "Categories",
        role: "products",
        action: "read",
        path: "/dashboard/products/categories",
        sidebar: true,
        icon: FolderIcon,
        element: ProductCategoriesList,
      },
      {
        title: "Settings",
        role: "product_settings",
        path: "/dashboard/products/settings",
        sidebar: true,
        icon: FolderIcon,
        element: ProductsSettings,
      },
      {
        title: "Product",
        role: "products",
        action: "read",
        path: "/dashboard/products/:id",
        sidebar: false,
        icon: Cog6ToothIcon,
        element: Product,
      },
      // Inventory as submenu under Products
      {
        title: "Inventory",
        path: "/dashboard/inventory",
        role: "inventory",
        sidebar: true,
        icon: CircleStackIcon,
        element: InventoryList,
        children: [
          {
            title: "Overview",
            role: "inventory",
            path: "/dashboard/inventory",
            sidebar: true,
            icon: FolderIcon,
            element: InventoryList,
          },
          {
            title: "Plukkliste",
            role: "inventory",
            path: "/dashboard/inventory/picking-list",
            sidebar: true,
            icon: ClipboardDocumentCheckIcon,
            element: PickingListPage,
          },
          {
            title: "Lagerbeholdning",
            role: "inventory",
            path: "/dashboard/inventory/warehouse-stock",
            sidebar: true,
            icon: FolderIcon,
            element: WarehouseStock,
          },
          {
            title: "inventoryValuation.title",
            role: "inventory_finance",
            action: "read",
            path: "/dashboard/inventory/valuation",
            sidebar: true,
            icon: CircleStackIcon,
            element: InventoryValuation,
          },
          {
            title: "Counts",
            role: "counts",
            action: "read",
            path: "/dashboard/inventory/counts",
            sidebar: true,
            icon: FolderIcon,
            element: InventoryCounts,
          },
          {
            title: "New Count",
            role: "counts",
            action: "create",
            path: "/dashboard/inventory/counts/new",
            sidebar: false,
            icon: FolderIcon,
            element: NewInventoryCount,
          },
          {
            title: "Count",
            role: "counts",
            action: "read",
            path: "/dashboard/inventory/counts/:id",
            sidebar: false,
            icon: FolderIcon,
            element: InventoryCount,
          },
          {
            title: "Korreksjoner",
            role: "inventory",
            path: "/dashboard/inventory/corrections",
            sidebar: true,
            icon: FolderIcon,
            element: InventoryCorrections,
          },
          {
            title: "Korreksjon",
            role: "inventory",
            action: "read",
            path: "/dashboard/inventory/corrections/:id",
            sidebar: false,
            icon: FolderIcon,
            element: InventoryCorrection,
          },
          {
            title: "Innkjøp",
            role: "inventory",
            path: "/dashboard/inventory/purchases",
            sidebar: true,
            icon: FolderIcon,
            element: Purchases,
          },
          {
            title: "Innkjøp",
            role: "inventory",
            action: "read",
            path: "/dashboard/inventory/purchases/:id",
            sidebar: false,
            icon: FolderIcon,
            element: Purchase,
          },
          {
            title: "Varemottak",
            role: "inventory",
            action: "read",
            path: "/dashboard/inventory/goods-receipts/new",
            sidebar: false,
            icon: FolderIcon,
            element: GoodsReceipt,
          },
          {
            title: "Varemottak",
            role: "inventory",
            action: "read",
            path: "/dashboard/inventory/goods-receipts/:id",
            sidebar: false,
            icon: FolderIcon,
            element: GoodsReceipt,
          },
          {
            title: "Varehåndtering",
            role: "inventory",
            action: "read",
            path: "/dashboard/inventory/item-handling/:item_list_id",
            sidebar: false,
            icon: FolderIcon,
            element: ItemHandlingPage,
          },
          {
            title: "Settings",
            role: "inventory_settings",
            path: "/dashboard/inventory/settings",
            sidebar: true,
            icon: FolderIcon,
            element: InventorySettings,
          },
        ],
      },
    ],
  },
  {
    title: "Orders",
    path: "/dashboard/orders",
    role: "orders",
    sidebar: true,
    icon: ClipboardDocumentListIcon,
    layout: NoLayout,
    children: [
      {
        title: "Orders",
        role: "orders",
        path: "/dashboard/orders",
        sidebar: true,
        icon: FolderIcon,
        element: OrdersList,
      },
      {
        title: "New Order",
        role: "orders",
        path: "/dashboard/orders/new",
        sidebar: true,
        icon: FolderIcon,
        element: Order,
      },
      {
        title: "Order",
        role: "orders",
        action: "create",
        path: "/dashboard/orders/:id",
        sidebar: false,
        icon: FolderIcon,
        element: Order,
      },
      {
        title: "Settings",
        role: "order_settings",
        path: "/dashboard/orders/settings",
        sidebar: true,
        icon: FolderIcon,
        element: OrdersSettings,
      },
    ],
  },
  {
    title: "Tilbud",
    path: "/dashboard/offers",
    role: "offers",
    sidebar: true,
    icon: MonetizationOn,
    layout: NoLayout,
    children: [
      {
        title: "Oversikt",
        role: "offers",
        path: "/dashboard/offers",
        sidebar: true,
        icon: FolderIcon,
        element: OffersList,
      },
      {
        title: "Nytt tilbud",
        role: "offers",
        path: "/dashboard/offers/new",
        sidebar: true,
        icon: FolderIcon,
        element: NewOffer,
      },
      {
        title: "Offer",
        role: "offers",
        path: "/dashboard/offers/:id",
        sidebar: false,
        icon: FolderIcon,
        element: Offer,
      },
      {
        title: "Kalkyler",
        role: "offers",
        path: "/dashboard/offers/calculations",
        sidebar: true,
        icon: FolderIcon,
        element: OfferCalculationsList,
      },
      {
        title: "Kalkyle",
        role: "offers",
        path: "/dashboard/offers/calculations/:id",
        sidebar: false,
        icon: FolderIcon,
        element: OfferCalculation,
      },
      {
        title: "Ny Kalkyle",
        role: "offers",
        path: "/dashboard/offers/calculations/new",
        sidebar: false,
        icon: FolderIcon,
        element: OfferCalculation,
      },
      {
        title: "Timesatser",
        role: "offers",
        path: "/dashboard/offers/hour-rates",
        sidebar: true,
        icon: FolderIcon,
        element: OfferCalculationHourRatesList,
      },
      {
        title: "Timesats",
        role: "offers",
        path: "/dashboard/offers/hour-rates/:id",
        sidebar: false,
        icon: FolderIcon,
        element: OfferCalculationHourRate,
      },
      {
        title: "Ny Timesats",
        role: "offers",
        path: "/dashboard/offers/hour-rates/new",
        sidebar: false,
        icon: FolderIcon,
        element: OfferCalculationHourRate,
      },
      {
        title: "Maler",
        role: "offers",
        path: "/dashboard/offers/templates/",
        sidebar: true,
        icon: FolderIcon,
        element: Offer,
      },
      {
        title: "Innstillinger",
        role: "admin",
        path: "/dashboard/offers/settings",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: OffersSettings,
      },
    ],
  },
  {
    title: "Service",
    path: "/dashboard/service",
    role: "service",
    sidebar: true,
    icon: WrenchIcon,
    layout: NoLayout,
    children: [
      {
        title: "Overview",
        role: "service",
        path: "/dashboard/service/",
        sidebar: true,
        icon: FolderIcon,
        element: ServiceOverview,
      },
      {
        title: "Reports",
        role: "service_reports",
        path: "/dashboard/service/reports",
        sidebar: true,
        icon: FolderIcon,
        element: ReportList,
      },
      {
        title: "Report",
        role: "service_reports",
        path: "/dashboard/service/reports/:id",
        sidebar: false,
        icon: FolderIcon,
        element: ReportViewV2,
      },
      {
        title: "Report Checklist",
        role: "service_reports",
        path: "/dashboard/service/reports/:id/checklist",
        sidebar: false,
        icon: FolderIcon,
        element: ReportChecklistPage,
      },
      {
        title: "Report Variables",
        role: "service_reports",
        path: "/dashboard/service/reports/:id/variables",
        sidebar: false,
        icon: FolderIcon,
        element: ReportVariablesPage,
      },
      {
        title: "Report Item Consumption",
        role: "service_reports",
        path: "/dashboard/service/reports/:id/item-consumption",
        sidebar: false,
        icon: FolderIcon,
        element: ReportItemConsumptionPage,
      },
      {
        title: "Finish Report",
        role: "service_reports",
        path: "/dashboard/service/reports/:id/finish",
        sidebar: false,
        icon: FolderIcon,
        element: ReportFinishPageV2,
      },
      {
        title: "Agreements",
        role: "service_agreements",
        path: "/dashboard/service/agreements",
        sidebar: true,
        icon: FolderIcon,
        element: ServiceAgreementList,
      },
      {
        title: "Agreement",
        role: "service_agreements",
        path: "/dashboard/service/agreements/:id",
        sidebar: false,
        icon: FolderIcon,
        element: ServiceAgreement,
      },
      {
        title: "Settings",
        role: "service_settings",
        path: "/dashboard/service/settings",
        sidebar: true,
        icon: FolderIcon,
        element: ServiceSettings,
      },
      {
        title: "Report Guides",
        role: "service_settings",
        path: "/dashboard/service/settings/report-guides",
        sidebar: false,
        icon: FolderIcon,
        element: ServiceReportGuides,
      },
    ],
  },
  {
    title: "Driving Record",
    path: "/dashboard/driving",
    roles: ["driving", "driving_trips", "driving_vehicles"],
    sidebar: true,
    icon: MapIcon,
    layout: NoLayout,
    children: [
      {
        title: "Trips",
        roles: ["driving_trips", "driving"],
        path: "/dashboard/driving/trips",
        sidebar: true,
        icon: FolderIcon,
        element: DrivingTrips,
      },
      {
        title: "Vehicle handbook",
        roles: ["driving_vehicles", "driving_trips", "driving", "vehicles"],
        path: "/dashboard/driving/my-vehicle-handbook",
        sidebar: true,
        icon: BookOpenIcon,
        element: VehicleHandbookEntry,
      },
      {
        title: "Drivers",
        role: "driving_drivers",
        path: "/dashboard/driving/drivers",
        sidebar: true,
        icon: FolderIcon,
        element: DrivingDrivers,
      },
      {
        title: "Vehicles",
        drivingFleetVehiclesList: true,
        path: "/dashboard/driving/vehicles",
        sidebar: true,
        icon: FolderIcon,
        element: VehiclesList,
      },
      {
        title: "Vehicles Item",
        roles: ["driving_vehicles", "driving_trips", "driving"],
        path: "/dashboard/driving/vehicles/:id",
        sidebar: false,
        icon: FolderIcon,
        element: Vehicle,
      },
      {
        title: "Vehicle Handbook",
        roles: ["driving_vehicles", "driving_trips", "driving"],
        path: "/dashboard/driving/vehicles/:id/handbook",
        sidebar: false,
        icon: FolderIcon,
        element: DriverVehicleHandbook,
      },
    ],
  },
  {
    title: "Tools",
    path: "/dashboard/tools",
    role: "tools",
    sidebar: true,
    icon: WrenchIcon,
    layout: NoLayout,
    children: [
      {
        title: "Tools Overview",
        role: "tools",
        path: "/dashboard/tools",
        sidebar: true,
        icon: FolderIcon,
        element: ToolsOverview,
      },
      {
        title: "Tool",
        role: "tools",
        path: "/dashboard/tools/:id",
        sidebar: false,
        icon: FolderIcon,
        element: ToolView,
      },
    ],
  },
  {
    title: "Resource Hub",
    path: "/dashboard/resource-hub",
    role: "resource_hub",
    sidebar: true,
    icon: AcademicCapIcon,
    layout: NoLayout,
    children: [
      {
        title: "FAQ",
        role: "resource_hub",
        path: "/dashboard/resource-hub/faq",
        sidebar: true,
        icon: FolderIcon,
        element: ResourceHubFaqFront,
      },
      {
        title: "FAQ User Type",
        role: "resource_hub",
        path: "/dashboard/resource-hub/faq/:userType",
        sidebar: false,
        icon: FolderIcon,
        element: ResourceHubFaqPage,
      },
      {
        title: "FAQ Main Category",
        role: "resource_hub",
        path: "/dashboard/resource-hub/faq/:userType/:mainCategoryId",
        sidebar: false,
        icon: FolderIcon,
        element: ResourceHubFaqPage,
      },
      {
        title: "FAQ Child Category",
        role: "resource_hub",
        path: "/dashboard/resource-hub/faq/:userType/:mainCategoryId/:childCategoryId",
        sidebar: false,
        icon: FolderIcon,
        element: ResourceHubFaqPage,
      },
      {
        title: "Edit FAQ Post",
        role: "resource_hub",
        path: "/dashboard/resource-hub/faq/editPost/:id",
        sidebar: false,
        icon: FolderIcon,
        element: EditFaqPost,
      },
      {
        title: "New FAQ Post",
        role: "resource_hub",
        path: "/dashboard/resource-hub/faq/newPost",
        sidebar: true,
        icon: FolderIcon,
        element: EditFaqPost,
      },
    ],
  },
  {
    title: "nav.documentation",
    path: "/dashboard/documentation",
    roles: ["meeting_minutes", "text_documents", "templates", "journals"],
    sidebar: true,
    icon: FolderOpenIcon,
    layout: NoLayout,
    children: [
      {
        title: "Møtereferat",
        path: "/dashboard/meeting-minutes",
        role: "meeting_minutes",
        sidebar: true,
        icon: DocumentTextIcon,
        children: [
          {
            title: "Møtereferat",
            role: "meeting_minutes",
            action: "read",
            path: "/dashboard/meeting-minutes",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesList,
          },
          {
            title: "Møtereferat",
            role: "meeting_minutes",
            action: "read",
            path: "/dashboard/meeting-minutes/:id",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesView,
          },
          {
            title: "Møte",
            role: "meeting_minutes",
            action: "read",
            path: "/dashboard/meeting-minutes/:id/meetings/:meetingId",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesMeetingView,
          },
          {
            title: "Nytt Møte",
            role: "meeting_minutes",
            action: "create",
            path: "/dashboard/meeting-minutes/:id/meetings/new",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesNewMeeting,
          },
          {
            title: "Nytt Møtereferat",
            role: "meeting_minutes",
            action: "create",
            path: "/dashboard/meeting-minutes/new",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesEditor,
          },
          {
            title: "Rediger Møtereferat",
            role: "meeting_minutes",
            action: "edit",
            path: "/dashboard/meeting-minutes/:id/edit",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesEditor,
          },
          {
            title: "Maler",
            role: "meeting_minutes_templates",
            action: "read",
            path: "/dashboard/meeting-minutes/templates",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesTemplatesList,
          },
          {
            title: "Ny Mal",
            role: "meeting_minutes_templates",
            action: "create",
            path: "/dashboard/meeting-minutes/templates/new",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesTemplateEditor,
          },
          {
            title: "Rediger Mal",
            role: "meeting_minutes_templates",
            action: "edit",
            path: "/dashboard/meeting-minutes/templates/:id/edit",
            sidebar: false,
            icon: FolderIcon,
            element: MeetingMinutesTemplateEditor,
          },
        ],
      },
      {
        title: "textDocuments.title",
        path: "/dashboard/text-documents",
        role: "text_documents",
        sidebar: true,
        icon: DocumentTextIcon,
        element: TextDocumentsList,
        children: [
          {
            title: "textDocuments.title",
            role: "text_documents",
            path: "/dashboard/text-documents",
            sidebar: false,
            icon: DocumentTextIcon,
            element: TextDocumentsList,
          },
          {
            title: "textDocuments.new",
            role: "text_documents",
            path: "/dashboard/text-documents/new",
            sidebar: false,
            icon: DocumentTextIcon,
            element: TextDocumentPage,
          },
          {
            title: "textDocuments.edit",
            role: "text_documents",
            path: "/dashboard/text-documents/:id",
            sidebar: false,
            icon: DocumentTextIcon,
            element: TextDocumentPage,
          },
        ],
      },
      {
        title: "Templates",
        path: "/dashboard/templates",
        role: "templates",
        sidebar: true,
        icon: PaperClipIcon,
        element: TemplateList,
        children: [
          {
            title: "Templates",
            role: "templates",
            path: "/dashboard/templates",
            sidebar: false,
            icon: FolderIcon,
            element: TemplateList,
          },
          {
            title: "New Template",
            role: "templates",
            path: "/dashboard/templates/new",
            sidebar: false,
            icon: FolderIcon,
            element: TemplatePage,
          },
          {
            title: "Edit Template",
            role: "templates",
            path: "/dashboard/templates/:id",
            sidebar: false,
            icon: FolderIcon,
            element: TemplatePage,
          },
        ],
      },
      {
        title: "journal.journals",
        path: "/dashboard/journals",
        role: "journals",
        sidebar: true,
        icon: BookOpenIcon,
        element: JournalsList,
      },
    ],
  },

  {
    title: "Website",
    path: "/dashboard/website",
    role: "website",
    sidebar: true,
    icon: ChartBarIcon,
    element: DashboardReport,
    layout: NoLayout,
    children: [
      {
        title: "Pages",
        role: "webpage",
        path: "/dashboard/webpage/pages",
        sidebar: true,
        icon: FolderIcon,
        element: WebpagesList,
      },
      {
        title: "Page",
        role: "webpage",
        path: "/dashboard/webpage/pages/:slug",
        sidebar: true,
        icon: FolderIcon,
        element: WebpageEditor,
      },
      {
        title: "Settings",
        role: "webpage",
        path: "/dashboard/webpage/settings",
        sidebar: true,
        icon: FolderIcon,
        element: WebpagesList,
      },
    ],
  },
  {
    title: "Tegninger",
    path: "/dashboard/drawings",
    // Sidebar goes straight to project picker (not last-used project).
    sidebarTo: "/dashboard/drawings?select_project=1",
    roles: ["drawings", "drawings_edit"],
    sidebar: true,
    icon: Square3Stack3DIcon,
    layout: NoLayout,
    children: [
      {
        title: "Tegninger",
        roles: ["drawings", "drawings_edit"],
        action: "read",
        path: "/dashboard/drawings",
        // Parent menu item is the sidebar link; hide duplicate child.
        sidebar: false,
        icon: FolderIcon,
        element: DrawingsList,
      },
      {
        title: "Ny Tegning",
        role: "drawings_edit",
        action: "create",
        path: "/dashboard/drawings/new",
        sidebar: false,
        icon: FolderIcon,
        element: DrawingEditor,
      },
      {
        title: "Rediger Tegning",
        role: "drawings_edit",
        action: "edit",
        path: "/dashboard/drawings/:id/edit",
        sidebar: false,
        icon: FolderIcon,
        element: DrawingEditor,
      },
      {
        title: "Tegning",
        roles: ["drawings", "drawings_edit"],
        action: "read",
        path: "/dashboard/drawings/:id",
        sidebar: false,
        icon: FolderIcon,
        element: DrawingViewer,
      },
    ],
  },
  {
    title: "Human resources",
    path: "/dashboard/hr",
    roles: ["users", "human_resources"],
    feature: "human_resources",
    sidebar: true,
    icon: UserGroupIcon,
    layout: NoLayout,
    children: [
      {
        title: "Employees",
        role: "users",
        path: "/dashboard/hr/employees",
        sidebar: true,
        icon: UsersIcon,
        element: HrEmployeesList,
      },
      {
        title: "Ledige stillinger",
        role: "human_resources",
        feature: "human_resources",
        action: "read",
        path: "/dashboard/hr/job-openings",
        sidebar: true,
        icon: BriefcaseIcon,
        element: JobOpeningsList,
      },
      {
        title: "Ledige stillinger",
        role: "human_resources",
        feature: "human_resources",
        action: "read",
        path: "/dashboard/hr/job-openings/:id",
        sidebar: false,
        icon: BriefcaseIcon,
        element: JobOpeningShow,
      },
      {
        title: "Kandidat",
        role: "human_resources",
        feature: "human_resources",
        action: "read",
        path: "/dashboard/hr/job-openings/:id/candidates/:candidateId",
        sidebar: false,
        icon: BriefcaseIcon,
        element: JobOpeningCandidateShow,
      },
      {
        title: "Innstillinger",
        role: "human_resources",
        feature: "human_resources",
        action: "read",
        path: "/dashboard/hr/settings",
        sidebar: true,
        icon: Cog6ToothIcon,
        element: HrSettings,
      },
    ],
  },
  {
    title: "Company",
    path: "/dashboard/company",
    role: "company",
    sidebar: true,
    icon: ChartBarIcon,
    layout: NoLayout,
    children: [
      {
        title: "trainingAdmin.title",
        path: "/dashboard/company/training",
        role: "admin",
        sidebar: false,
        icon: AcademicCapIcon,
        element: TrainingAdminLegacyRedirect,
      },
      {
        title: "announcements.title",
        path: "/dashboard/company/announcements",
        role: "admin",
        sidebar: true,
        icon: ChatBubbleLeftRightIcon,
        element: AnnouncementsPage,
      },
      {
        title: "Users",
        role: "users",
        path: "/dashboard/users",
        sidebar: true,
        icon: FolderIcon,
        element: CompanyUsersList,
      },
      {
        title: "Users",
        role: "users",
        path: "/dashboard/users/:id",
        sidebar: false,
        icon: FolderIcon,
        element: User,
      },
      {
        title: "Avdelinger",
        role: "admin",
        path: "/dashboard/company/departments",
        sidebar: true,
        icon: BuildingOffice2Icon,
        element: CompanyDepartmentsList,
      },
      {
        title: "Settings",
        role: "company",
        path: "/dashboard/company/settings",
        sidebar: true,
        icon: FolderIcon,
        element: CompanySettings,
      },
      {
        title: "Abonnement",
        role: "company",
        path: "/dashboard/company/subscription",
        sidebar: true,
        icon: FolderIcon,
        element: CompanySubscription,
      },
      {
        title: "Integrations",
        role: "company",
        path: "/dashboard/company/integrations",
        sidebar: true,
        icon: FolderIcon,
        element: CompanyIntegrations,
      },
      {
        title: "Delte innbokser",
        role: "admin",
        path: "/dashboard/company/microsoft",
        sidebar: true,
        icon: EnvelopeOpenIcon,
        element: CompanyMicrosoftOutlook,
      },
      {
        title: "History",
        role: "company",
        path: "/dashboard/company/history",
        sidebar: true,
        icon: FolderIcon,
        element: CompanyHistory,
      },
      {
        title: "E-postlogg",
        roles: ["admin", "customers"],
        action: "read",
        path: "/dashboard/communications",
        sidebar: true,
        icon: EnvelopeOpenIcon,
        element: OutboundCommunicationsList,
      },
      {
        title: "E-postlogg",
        roles: ["admin", "customers"],
        action: "read",
        path: "/dashboard/communications/:id",
        sidebar: false,
        icon: EnvelopeOpenIcon,
        element: OutboundCommunicationShow,
      },
    ],
  },
  {
    title: "Regnskap",
    path: "/dashboard/accounting",
    role: "accounting",
    sidebar: true,
    icon: BanknotesIcon,
    layout: NoLayout,
    children: [
      {
        title: "accounting.menu.overview",
        role: "accounting",
        action: "read",
        path: "/dashboard/accounting/overview",
        sidebar: true,
        icon: ChartBarIcon,
        element: AccountingOverviewPage,
      },
      {
        title: "accounting.menu.ledger",
        role: "accounting",
        action: "read",
        path: "/dashboard/accounting/ledger",
        sidebar: true,
        icon: TableCellsIcon,
        element: AccountingLedgerPage,
      },
      {
        title: "accounting.menu.result_report",
        role: "accounting",
        action: "read",
        path: "/dashboard/accounting/result-report",
        sidebar: true,
        icon: DocumentTextIcon,
        element: AccountingResultReportPage,
      },
      {
        title: "accounting.menu.project_summary",
        role: "accounting",
        action: "read",
        path: "/dashboard/accounting/project-summary",
        sidebar: true,
        icon: ChartBarIcon,
        element: AccountingProjectSummaryPage,
      },
      {
        title: "accounting.menu.projects_expected",
        role: "accounting",
        action: "read",
        path: "/dashboard/accounting/projects-expected-income",
        sidebar: false,
        element: AccountingProjectsExpectedIncomePage,
      },
      {
        title: "accounting.menu.tripletex_import",
        role: "accounting",
        action: "write",
        path: "/dashboard/accounting/tripletex-import",
        sidebar: true,
        icon: ArrowPathIcon,
        element: AccountingTripletexImportPage,
      },
      {
        title: "Leverandørfakturaer",
        role: "accounting",
        action: "read",
        path: "/dashboard/supplier-invoices",
        sidebar: true,
        icon: DocumentTextIcon,
        element: SupplierInvoiceList,
      },
      {
        title: "Leverandørfaktura",
        role: "accounting",
        action: "read",
        path: "/dashboard/supplier-invoices/:id",
        sidebar: false,
        icon: DocumentTextIcon,
        element: SupplierInvoiceDetail,
      },
      {
        title: "Kundefakturaer",
        role: "accounting",
        action: "read",
        path: "/dashboard/customer-invoices",
        sidebar: true,
        icon: DocumentTextIcon,
        element: CustomerInvoiceList,
      },
      {
        title: "Kundefaktura",
        role: "accounting",
        action: "read",
        path: "/dashboard/customer-invoices/:id",
        sidebar: false,
        icon: DocumentTextIcon,
        element: CustomerInvoiceDetail,
      },
    ],
  },

  {
    title: "Personalhåndbok",
    path: "/dashboard/quality/employee-handbook",
    role: "",
    sidebar: false,
    icon: BookOpenIcon,
    element: EmployeeHandbookView,
    layout: NoLayout,
  },
  {
    title: "Stoffkartotek",
    path: "/dashboard/quality/chemical-inventory",
    roles: ["hse_ks_risk", "chemical_inventory"],
    action: "read",
    sidebar: false,
    icon: BeakerIcon,
    element: ChemicalInventoryList,
    layout: NoLayout,
  },
  {
    title: "Stoffkartotek",
    path: "/dashboard/quality/chemical-inventory/:id",
    roles: ["hse_ks_risk", "chemical_inventory"],
    action: "read",
    sidebar: false,
    icon: BeakerIcon,
    element: ChemicalInventoryView,
    layout: NoLayout,
  },

  // Not displayed in sidebar
  {
    title: "User Profile",
    path: "/dashboard/user",
    sidebar: false,
    icon: ChartBarIcon,
    layout: NoLayout,
    children: [
      {
        title: "User Profile",
        path: "/dashboard/user/profile",
        sidebar: false,
        icon: ChartBarIcon,
        element: UserProfile,
      },
      {
        title: "User Settings",
        path: "/dashboard/user/settings",
        sidebar: false,
        icon: ChartBarIcon,
        element: UserSettings,
      },
      {
        title: "Microsoft / Outlook",
        path: "/dashboard/user/microsoft",
        sidebar: false,
        icon: ChartBarIcon,
        element: UserMicrosoftOutlook,
      },
    ],
  },
  {
    title: "User Settings",
    path: "/dashboard/user/settings",
    sidebar: false,
    icon: ChartBarIcon,
    layout: StandardLayout,
    children: [],
  },
];
